// extracted by mini-css-extract-plugin
module.exports = {"form":"CheckOut_form__2k9Av","control":"CheckOut_control__38rH8","actions":"CheckOut_actions__35Baz","submit":"CheckOut_submit__3_zOG","invalid":"CheckOut_invalid__36krv"};